module.exports = __webpack_public_path__ + "static/media/initials.d27d710b.png";